import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { CircularProgress } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { ClassKeyOfStyles, ClassNameMap } from '@material-ui/styles/withStyles';
import * as authActions from '../../store/actions/auth_actions';
import { IState } from '../../store/reducers';
import style from './styles';

// import useRedirect from './RedirectHook';

interface IProps {
  classes: ClassNameMap<ClassKeyOfStyles<string>>;
  postOAuthTokenRequest: (bexioLoginRequest: any) => any;
  redirectPath: string;
  sumupAuthenticated: boolean;
  token: string;
  location: {
    search: string;
    pathname: string;
  };
}

const SumupOAuthHandler: React.FC<IProps> = props => {
  const { classes, sumupAuthenticated, location, postOAuthTokenRequest } = props;

  const [doRedirect, setDoRedirect] = useState<boolean>(false);

  useEffect(() => {
    if (sumupAuthenticated) {
      setDoRedirect(true);
    }
  }, [sumupAuthenticated]);

  // didMount fetch data
  useEffect(() => {
    if (location) {
      if (sumupAuthenticated) {
        setDoRedirect(true);
      }

      const params = new URLSearchParams(location.search);

      if (params.get('code')) {
        postOAuthTokenRequest({ system: 'sumup', code: params.get('code') });
      }
    }
  }, []);

  return (
    <div className={classes.container}>
      {doRedirect && <Redirect to={props.redirectPath ? props.redirectPath : '/admin/sumup-app'} />}
      <CircularProgress size={100} />
      {/*<button onClick={() => setDoRedirect(true)}>Redirect</button>*/}
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  sumupAuthenticated: state.sumup.authenticated,
  redirectPath: state.auth.redirectPath,
});

const mapDispatchToProps = {
  postOAuthTokenRequest: authActions.postOAuthTokenRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(style)(SumupOAuthHandler));
